import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";
import { getSeverity } from "../../utils/getSeverity";
import ScoreMeter from "src/shared/components/ScoreMeter";
import { useGetPatientScoresQuery } from "src/api/services/mentalHealthApi";

interface Props {
  onNavigate: () => void;
}

const Gad7Card = ({ onNavigate }: Props) => {
  const { t } = useTranslation();
  const component = "amh-review";
  const { data = { gad7: 0 } } = useGetPatientScoresQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const gad7SeverityLabel = useMemo(() => {
    const label = getSeverity("GAD-7", data.gad7);
    if (label == null) return null;

    return `${t(`${component}.label.${label.toLowerCase()}`, label)} ${t(
      `${component}.anxiety`,
      "Anxiety"
    )}`;
  }, [data.gad7, t]);

  return (
    <WhiteCard
      sx={{
        borderRadius: "30px",
        background: `linear-gradient(
        180deg,
        rgba(0, 182, 185, 0.75) 0.31%,
        rgba(255, 255, 255, 0.36) 99.69%
      ),
      #00B6B9`,
        padding: "40px 40px 20px 40px",
      }}
      gap={12}
      onClick={onNavigate}
    >
      <Typography color="#ffffff" variant="h4">
        {gad7SeverityLabel}
      </Typography>
      <Stack gap={5}>
        <ScoreMeter score={data.gad7} threshold={[0, 5, 10, 16, 21]} />
        <Typography variant="body2" color="#ffffff" textAlign={"center"}>
          {t(`${component}.gad-7.disclaimer`, "Measured by the GAD-7")}
        </Typography>
      </Stack>
    </WhiteCard>
  );
};

export default Gad7Card;
